import { useEffect, useState } from "react";
import { searchHotels } from "../services/hotelApi";

const HolidayDetails = () => {
  const [hotels, setHotels] = useState([]);

  useEffect(() => {
    searchHotels({
      destinationId: "6054439", // example region
      checkIn: "2026-02-10",
      checkOut: "2026-02-12",
      adults: 2,
    }).then((data) => {
      setHotels(data?.data?.propertySearch?.properties || []);
    });
  }, []);

  return (
    <div>
      <h2>Available Hotels</h2>

      {hotels.map((hotel) => (
        <div key={hotel.id}>
          <h3>{hotel.name}</h3>
          <p>Price: {hotel.price?.lead?.formatted}</p>
        </div>
      ))}
    </div>
  );
};

export default HolidayDetails;
